import { PlexStreamSettingsSchema, } from './schemas/settingsSchemas.js';
export const defaultPlexStreamSettings = PlexStreamSettingsSchema.parse({});
//# sourceMappingURL=MediaSourceSettings.js.map